<template>
    <div class="quality-course-container">
        <div class="header">
            <h3 class="logo">
                <!-- <img src="../../assets/images/jd_course_logo.png"> -->
                {{ appName }}
            </h3>

            <div class="user" v-if="isLogin">
                <div class="user-info">
                    <div class="user-avatar">
                        <img :src="userIcon ? userIcon : require('../../assets/images/user_img.png')" alt="" />
                    </div>
                    <el-dropdown class="header-el-dropdown" v-if="isLogin" @command="logout" placement="bottom">
                        <span class="user-text">
                            <span class="user-name text-overflow">{{ username }}</span>
                            <i class="el-icon-arrow-down"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item command="2">个人中心</el-dropdown-item> -->
                            <el-dropdown-item icon="el-icon-switch-button" command="1">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

        <div class="quality-course-content">
            <router-view />
        </div>
    </div>
</template>

<script>
import config from '@/config/config';
export default {
    name: "index",
    components: {},
    data() {
        return {
            isLogin: false,
            role: "",
            username: "",
            userIcon: "",
        };
    },
    watch: {
        $route(to, from) {
            this.isLogin = localStorage.getItem("sUsername") ? true : false;

            this.watchRole();
        },
    },
    created() {
        this.isLogin = localStorage.getItem("sUsername") ? true : false;

        this.watchRole();
    },
    mounted() {
        this.username = localStorage.getItem("sUsername");

        let userIcon = localStorage.getItem("sIcon");
        if (userIcon !== "null") {
            this.userIcon = userIcon;
        }
    },
    computed: {
        appName: () => config.appName,
    },
    methods: {
        watchRole() {
            this.role = parseInt(localStorage.getItem("role"));
        },
        logout(command) {
            if (command == 1) {
                this.$shttp.axiosGet(this.$api.logout, (res) => {
                    if (res.code === 200) {
                        this.$message({
                            type: "success",
                            duration: 1000,
                            message: res.msg,
                            onClose: () => {
                                localStorage.clear();
                                if (this.$route.path === "/") {
                                    window.location.reload();
                                } else {
                                    this.$router.push("/");
                                }
                            },
                        });
                    } else {
                        this.$message({
                            type: "warning",
                            duration: 1000,
                            message: res.msg,
                            onClose: () => {
                                localStorage.clear();
                                if (this.$route.path === "/") {
                                    window.location.reload();
                                } else {
                                    this.$router.push("/");
                                }
                            },
                        });
                    }
                });
            } else {
                console.log("前往个人中心");
                this.$router.push("/qualityCourse/IndividualCenter");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.quality-course-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;

    .header {
        position: relative;
        height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-inline: 150px 100px;

        .nav {
            flex: 1;
            width: 1%;
            border-bottom: none;
            .el-menu-item {
                padding: 0;
                .nav-item {
                    display: block;
                    padding: 0 20px;
                }
            }
        }

        .logo {
            /*width: 200px;*/
            font-size: 18px;
            font-weight: 600;
            overflow: hidden;
            margin: 0;
            color: #409eff;
        }

        .user {
            text-align: right;
            margin-left: 20px;
            display: flex;

            .m-userinfo {
                a {
                    display: block;
                    font-size: 16px;
                    color: #666;
                }
            }

            .header-el-dropdown {
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 10px 0;

                .user-text {
                    line-height: 40px;
                    margin-left: 10px;
                }
                img {
                    display: block;
                    width: 36px;
                    height: 36px;
                    border-radius: 50%;
                }
            }

            .el-dropdown-menu {
                ::v-deep li {
                    padding: 0 25px 0 10px;
                    height: 27px;
                    line-height: 27px;
                    font-size: 14px;
                    color: #666;
                    &:hover {
                        color: #4a90e2;
                        background-color: transparent;
                    }
                    i {
                        font-size: 16px;
                        color: #666;
                    }
                }
            }

            .user-info {
                display: flex;
                align-items: center;
                height: 70px;
                .user-avatar {
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #ddd;
                    img {
                        max-width: 100%;
                        max-height: 100%;
                    }
                }
                .el-dropdown {
                    .user-text {
                        display: flex;
                        align-items: center;
                        &:hover {
                            color: #409eff;
                        }
                        .user-name {
                            max-width: 80px;
                            display: block;
                            cursor: pointer;
                            &:focus {
                                outline: none;
                            }
                        }
                    }
                    // padding-left: 20px;
                }
            }

            span {
                font-size: 16px;
                margin-right: 20px;
            }
        }
    }

    .quality-course-content {
        background-color: #efefef;
        overflow: hidden;
        height: calc(100% - 70px);
    }
}
</style>
